import AxiosWrapper from '../utils/AxiosWrapper';

export async function PostReciprocalInvoices(company, { invoice }) {
  try {
    let url = `${process.env.API_URL}/${company}/reciprocal-invoice`;

    let res = await AxiosWrapper({
      method: 'POST',
      url: url,
      data: invoice,
      isAuthRoute: true
    });
    return res;
  } catch (e) {
    console.error(e);
  }
}